export default {
  getCity: '/gateway/courier/cities/queryCitiesByParentId/list'
}
